import { toArray } from '@/helpers'
import {
  AuthPopup,
  PrimarySubmitButton,
  TextBlock,
  TextBlockDirection,
  TextBoxCaption3,
  TextBoxHeadline1,
} from '@setplex/arcana'
import type { JSX } from 'react'
import { AuthLayout } from '~/widgets/auth'

interface Props {
  title: string
  body: string | string[]
  button: string
  to: string
}

FinalMessage.displayName = 'FinalMessage'
export function FinalMessage({ title, body, button, to }: Props): JSX.Element {
  return (
    <AuthLayout>
      <AuthPopup>
        <TextBoxHeadline1 title={title} />
        <TextBlock direction={TextBlockDirection.COLUMN}>
          {toArray(body).map((p, i) => (
            <TextBoxCaption3 key={i} title={p} />
          ))}
        </TextBlock>
        <a href={to}>
          <PrimarySubmitButton title={button} />
        </a>
      </AuthPopup>
    </AuthLayout>
  )
}
